import container from '../container';

export default function ControllerViewFactory({ type, name, state, label }) {
  const RenderView = container.getViewRender(type);

  if (RenderView) return <RenderView state={state} label={label} name={name} />;

  return (
    <p data-testid="noViewFound">
      No View found for {name} of type {type}
    </p>
  );
}
